import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import CardIcon from '@pedidosya/web-fenix/icons/CardIcon';
import { sessionCache, KEYS } from '@services/cache';
import { Container, Content, Text, Pointer } from './components';
import messages from './messages';

const THREE_SECONDS_IN_MS = 3000;
const MAX_COUNT_TOOLTIP = 2;
const TOOLTIP_TYPE = 'only_online_payment';

const Tooltip = ({
  isDesktop,
  intl: { formatMessage },
  isPickup,
  trackTooltipShown,
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const counter = sessionCache.get(KEYS.TOOLTIP_ONLINE_PAYMENT) || 0;
    if (isPickup && counter < MAX_COUNT_TOOLTIP) {
      sessionCache.set(KEYS.TOOLTIP_ONLINE_PAYMENT, counter + 1);
      setShow(true);
    } else {
      setShow(false);
    }
  }, [isPickup]);

  useEffect(() => {
    let timer = null;
    if (show) {
      trackTooltipShown({ tooltipType: TOOLTIP_TYPE });
      timer = setTimeout(() => {
        setShow(false);
      }, THREE_SECONDS_IN_MS);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [show, trackTooltipShown]);

  return (
    show && (
      <Container isDesktop={isDesktop}>
        <Content>
          <CardIcon color="white" size="small" />
          <Text>{formatMessage(messages.onlyPaymentOnline)}</Text>
          <Pointer isDesktop={isDesktop} />
        </Content>
      </Container>
    )
  );
};

Tooltip.propTypes = {
  isDesktop: PropTypes.bool,
  intl: intlShape.isRequired,
  isPickup: PropTypes.bool,
  trackTooltipShown: PropTypes.func.isRequired,
};

export default memo(injectIntl(Tooltip));
